import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_button = _resolveComponent("a-button");
  return _openBlock(), _createBlock(_component_a_button, {
    disabled: $setup.btnDisabled,
    type: $props.type,
    danger: $props.danger,
    loading: $props.loading,
    onClick: $setup.handleClick
  }, {
    icon: _withCtx(() => [_renderSlot(_ctx.$slots, "icon")]),
    default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($setup.btnTitle), 1)]),
    _: 3
  }, 8, ["disabled", "type", "danger", "loading", "onClick"]);
}